import { render, staticRenderFns } from "./CardsTransactions.vue?vue&type=template&id=46abc0fb&"
import script from "./CardsTransactions.vue?vue&type=script&lang=js&"
export * from "./CardsTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports